import { Injectable } from "@angular/core";
import { Store, StoreConfig } from "@datorama/akita";
import { NerriSession } from "../../../api/auth/model/session";

export interface UnauthorizedState {
    session: NerriSession | null;
}

export function createInitialState(): UnauthorizedState {
    return {
        session: null
    };
}

@Injectable()
@StoreConfig({ name: "unauthorized" })
export class UnauthorizedStore extends Store<UnauthorizedState> {
    constructor() {
        super(createInitialState());
    }
}
